import { useEffect, useState } from "react";
import "./PhaseSlider.scss";
import Helpers from "@utils/Helpers";
import { Slider } from "antd";
import { IPipeline } from "@utils/Interfaces";

const PhaseSlider: React.FC<any> = ({ tasks }) => {
  const [marks, setMarks] = useState<any>({});

  useEffect(() => {
    if (tasks) {
      let lineStep = 0;
      const newMarks = { ...marks };

      tasks.forEach((element: any) => {
        const startDate = Helpers.formattedUTC(element.start_date);
        newMarks[lineStep] = startDate;
        lineStep += 12.5;
      });

      setMarks(newMarks);
    }
  }, [tasks]);

  const tooltipFormatter = (value: any) => {
    // Customize tooltip based on the value of `marks`
    return `${value}%`;
  };

  return (
    <div className="Slider">
      <Slider
        className="pharse-slider"
        marks={marks}
        tooltip={{ formatter: tooltipFormatter }}
      />
    </div>
  );
};

export default PhaseSlider;
